export default __webpack_public_path__ + "img/7a132fb9ee4a0835d9b90768b02389ce.svg";